import React from 'react'
import { Alert } from 'react-bootstrap'

function Message({variant, children}) {
  return (
    <Alert style={{fontSize: '16px', padding: '0.5em 1em', margin: '0'}} variant={variant}>
      {children}
    </Alert>
  )
}

export default Message
